import ExerciseImage from "./ExerciseImage";
import {memo, useEffect, useState} from "react";
import "./TaskCreator.css"
import { v4 as uuidv4 } from 'uuid';

const DEFAULT_QUESTIONS = () => [
    {id: uuidv4(), image: null, answer: ''},
    {id: uuidv4(), image: null, answer: ''},
    {id: uuidv4(), image: null, answer: ''},
    {id: uuidv4(), image: null, answer: ''}
];

const TaskCreator = ({onPressAdd, isEditMode = false, initialQuestions, index, onEditTask, onRemove}) => {
    const [questions, setQuestions] = useState(initialQuestions || DEFAULT_QUESTIONS());

    const handlePress = () => {
        if(isEditMode) {
            handleOnEditPress();
        } else {
            handleOnPressAdd();
        }
    }
    
    const handleOnPressAdd = () => {
        onPressAdd({id: uuidv4() , questions});
        setQuestions(DEFAULT_QUESTIONS());
    }

    const handleOnEditPress = () => {
        onEditTask(questions, index)
    }
    
    const onImageChange = (image, index) => {
        const array = [...questions];
        array[index] = {...array[index], image: image};
        setQuestions(array);
    }

    const onAnswerChange = (answer, index) => {
        const array = [...questions];
        array[index] = {...array[index], answer: answer};
        setQuestions(array);
    }
    
    
    
    return (
            <div className={"taskCreator"}>
                {isEditMode && <span className={"delete"} onClick={() => onRemove(index)}>X</span>}
                <div className={"row"}>
                    <ExerciseImage index={0} 
                                   source={questions[0]?.image} 
                                   onImageChange={onImageChange}
                                   onAnswerChange={onAnswerChange} 
                                   answer={questions[0]?.answer}/>
                    <ExerciseImage index={1} 
                                   source={questions[1]?.image} 
                                   onImageChange={onImageChange}
                                   onAnswerChange={onAnswerChange} 
                                   answer={questions[1]?.answer}/>
                </div>
                <div className={"row"}>
                    <ExerciseImage index={2} 
                                   source={questions[2]?.image} 
                                   onImageChange={onImageChange}
                                   onAnswerChange={onAnswerChange} 
                                   answer={questions[2]?.answer}/>
                    <ExerciseImage index={3} 
                                   source={questions[3]?.image} 
                                   onImageChange={onImageChange}
                                   onAnswerChange={onAnswerChange} 
                                   answer={questions[3]?.answer}/>
                </div>
                <button className={"imagesButton"} onClick={handlePress}>{isEditMode ? 'Edytuj zadanie' : 'Dodaj zadanie'}</button>
            </div>
    )
}

export default memo(TaskCreator);